import { apiClient } from './client'
import type { ApiResponse } from './client'

export interface DropboxAuthStatusResult {
    ProviderEmail: string
    IsConnected: boolean
    AccessTokenExpiresUtc?: string | null
}

export interface DropboxAuthInitiateResult {
    authorizationUrl: string
}

export const dropboxAuthApi = {
    /** Get the OAuth authorization URL to open in popup */
    initiate: async (): Promise<ApiResponse<DropboxAuthInitiateResult>> => {
        return apiClient.get('/api/Auth/Dropbox/Initiate')
    },

    /** Check if user has connected their Dropbox account */
    getStatus: async (): Promise<ApiResponse<DropboxAuthStatusResult>> => {
        return apiClient.get('/api/Auth/Dropbox/Status')
    },

    /** Disconnect the user's Dropbox account */
    disconnect: async (): Promise<ApiResponse<void>> => {
        return apiClient.delete('/api/Auth/Dropbox/Disconnect')
    },
}
